import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import ItemService from "../../../services/supplier_appCommonService";

//Redux
import { useSelector } from "react-redux"; //useDispatch

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";
import toast from "react-hot-toast";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { formatDateTime, getCurrentDate } from "../../../common/Validations";
import Loader from "../../../Components/Loader";
import RichTextEditor from "../../../Components/Editor/RichTextEditor";
import HeaderText from "./HeaderText";
const TndQtnDetails = () => {
  // eslint-disable-next-line no-unused-vars
  // const dispatch = useDispatch();
  localStorage.setItem("menu", "Tender");
  localStorage.setItem("submenu", "Tender Quotation list");

  let quotationListInfo = useSelector(
    (state) => state?.purchasing?.tndQuotation?.tndQtnNr,
  ); /* quotationListInfo from store*/

  const [data, setData] = useState();

  const productTypeCode = data?.productTypeCode; // "MAT" or "SER"

  let dropdownOption = [
    {
      id: "1",
      name: "Sample Data 1",
    },
    {
      id: "2",
      name: "Sample Data 2",
    },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);

  const [itemTableData, setItemTableData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [disabled, setDisabled] = useState(true);
  const [userId, setUserId] = useState(true);
  const [userName, setUserName] = useState(true);
  const [getLoader, setLoader] = useState(true);

  const [formInputs, setFormInputs] = useState({
    quotationNr: quotationListInfo?.quotationNr,
    qtnVersion: quotationListInfo?.qtnVersion,
    rfxNr: "",
    quotationSubmittedBy: "",
    qtnSubmittedID: "",
    vendorCode: "",
    rfxCategoryDesc: "",
    rfqCreation: "",
    rfxDescription: "",
    rfxVersion: "",
    rfxTitle: "",
    openingrfxType: "",
    productType: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    qtnPaymentTerms: "",
    qtnBidderCurrency: "",
    technicalQuoteArticle: "",
    qtnPricingNotes: "",
    unpricedCommercia: "",
    lQuoteArticle: "",
    quotationNotes: "",
    commercialQuoteArticle: "",
    quotationStatus: "",
    buyerResponsible: "",
    companyAddress: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    createdOn: "",
    buyerConact: "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCateDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    openingDateTime: "",
    closingDateTime: "",
    rfxTypeDesc: "",
    productTypeDesc: "",
    rfxbidTypeDesc: "",
    rfxNoOfEvaluationTypeDesc: "",
    rfxCurrencyCode: "",
    rfxCurrencyDesc: "",
    technicalApprovalTypeDesc: "",
    companyAddressDesc: "",
    plantDesc: "",
    billingAddressDesc: "",
    unpricedCommercialQuoteArticle: "",
    pricingNotes: "",
    qtnIncoTerms: "",
    quotationReference: "",
    acceptanceTermsConditions: "",

    items: [
      {
        qtnItem: 1,
        nstatusItem: "",
        qtnQuantity: 10,
        qtnQuantityUnit: "",
        purchaseDocumentNr: "",
        purchaseDocumentItem: "",
        quotationNr: "",
      },
    ],
    formCOMM: [],
    formTECH: [],
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  const handleDeliveryLeadTime = (id, value) => {
    const updatedData = itemTableData.map((item) => {
      return item.local_id === id
        ? {
            ...item,
            deliveryLeadTime: value,
          }
        : item;
    });
    setItemTableData(updatedData);
  };

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      sortable: true,
      width: "120px",
    },
    {
      name: "Qtn Quantity ",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="qtnQuantity"
            name="qtnQuantity"
            value={row.qtnQuantity || 0}
            disabled={disabled}
          />
        </>
      ),
      width: "160px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      width: "100px",
    },
    {
      name: "Unit Price ",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="quotationUnitPrice"
            name="quotationUnitPrice"
            value={row.quotationUnitPrice || 0}
            disabled={disabled}
          />
        </>
      ),
    },
    {
      name: "Item Value ", // calculation
      selector: (row) => row.qtnitemValue || "--",
      width: "120px",
    },
    {
      name: "Delivery Lead Time (Days)", // input
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="deliveryLeadTime"
            name="deliveryLeadTime"
            value={row?.deliveryLeadTime || 0}
            disabled={disabled}
          />
        </>
      ),
      width: "200px",
    },
    ...(productTypeCode !== "MAT"
      ? [
          {
            name: "Service Start Date", // input
            cell: (row) => (
              <>
                <InputField
                  type="date"
                  className="inputBox mt-1"
                  id="serviceStartDate3"
                  name="serviceStartDate"
                  value={row?.serviceStartDate}
                  onChange={(e) =>
                    handleDeliveryLeadTime(row.local_id, e.target.value)
                  }
                />
              </>
            ),
            width: "200px",
          },
          {
            name: "Service End Date", // input
            selector: (row) => row.serviceEndDate || "--",
            cell: (row) => (
              <>
                <InputField
                  type="date"
                  className="inputBox mt-1"
                  id="serviceEndDate4"
                  name="serviceEndDate"
                  value={row?.serviceEndDate}
                  onChange={(e) =>
                    handleDeliveryLeadTime(row.local_id, e.target.value)
                  }
                />
              </>
            ),
            width: "200px",
          },
        ]
      : []),
    {
      name: "Deviation", // input yes/NO
      selector: (row) => row.deviation || "--",
      cell: (row) => (
        <>
          <ComboboxField
            placeholder=""
            data={dropdownOption}
            id="deviation"
            name="deviation"
            value={row?.deviation || 0}
            disabled={disabled}
          />
        </>
      ),
      width: "200px",
    },
    {
      name: "Deviation Remarks", // input
      selector: (row) => row.deviationRemark || "--",
      cell: (row) => (
        <>
          <TextAreaField
            className="inputBox mt-1"
            id="deviation"
            name="deviation"
            value={row?.deviation}
            disabled={disabled}
          />
        </>
      ),
      width: "200px",
    },
  ];

  // Other Charges
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);

  /* Other Charges selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  useEffect(() => {
    const getTotal = getHeaderTextSelectedData?.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue?.documentText || 0),
      0,
    );
    setOtherChargesValue(getTotal);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeaderTextSelectedData]);

  /* Create Other Charges Modal Function */
  // eslint-disable-next-line no-unused-vars
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Value",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
  ];

  const loadInitialPageData = async () => {
    // setLoading(true);
    if (quotationListInfo) {
      let obj = {
        documentNumber: quotationListInfo?.quotationNr,
        qtnVersion: quotationListInfo?.qtnVersion,
        queryName: "GET_Quotation_Detail",
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.generateQueryV1(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setItemTableData(item?.data[0]?.items);
          setFormInputs(item.data[0]);
          setData(item?.data?.[0]);

          setUserId(item?.data[0]?.supplierList?.AssociateNumber);
          setUserName(item?.data[0]?.supplierList?.organisationName);
          setHeaderTextSelectedData(item?.data[0]?.othersCharge);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadInitialPageData();
    getMasterDataFunc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotationListInfo]);

  //Load Master Data
  const getMasterDataFunc = async () => {
    setLoader(false);
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Quotation:
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs?.quotationNr}
              </span>
              <span>
                {formInputs?.quotationStatus === "Published" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : formInputs?.quotationStatus === "QTN Received" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : formInputs?.quotationStatus === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : formInputs?.quotationStatus === "RFQ Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : formInputs?.quotationStatus === "Submitted" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.quotationStatus}
                  </span>
                ) : (
                  formInputs?.quotationStatus
                )}
              </span>
              <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                {userId} - {userName}
              </span>
            </h2>
            <p className="subText">Quotatoin Details</p>
            <hr />

            <Loader isLoading={getLoader} className={"text-center"} />

            {!getLoader && (
              <>
                {/*quotation Header */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">QH</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Quotation Header</span>
                          <span className="subHeaderTitle">
                            Header Description
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="RFQ ID"
                              label={
                                <>
                                  <i className="bi bi-hash labelIcon"></i>
                                  RFQ ID
                                </>
                              }
                              name="rfxNr"
                              id="rfxNr"
                              placeholder=""
                              value={formInputs?.rfxNr}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Company Address"
                              label={
                                <>
                                  <i className="bi bi-building labelIcon"></i>
                                  Company Address
                                </>
                              }
                              name="companyAddressDesc"
                              id="companyAddressDesc"
                              placeholder=""
                              value={formInputs?.companyAddressDesc}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Delivery Address"
                              label={
                                <>
                                  <i className="bi bi-truck labelIcon"></i>
                                  Delivery Address
                                </>
                              }
                              name="billingAddressDesc"
                              id="billingAddressDesc"
                              value={formInputs?.billingAddressDesc}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="quotationCreatedOn"
                              className="inputBox"
                              // label="Quotation Created Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-event labelIcon"></i>
                                  Quotation Created Date
                                </>
                              }
                              name="quotationCreatedOn"
                              placeholder=""
                              value={getCurrentDate("default")}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Billing Address"
                              label={
                                <>
                                  <i className="bi bi-receipt labelIcon"></i>
                                  Billing Address
                                </>
                              }
                              name="billingAddressDesc"
                              id="billingAddressDesc"
                              value={formInputs?.billingAddressDesc}
                              // onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Buyer Responsible"
                              label={
                                <>
                                  <i className="bi bi-person-badge labelIcon"></i>
                                  Buyer Responsible
                                </>
                              }
                              name="buyerResponsible"
                              id="buyerResponsible"
                              value={formInputs?.buyerResponsible}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Product Type"
                              label={
                                <>
                                  <i className="bi bi-box-seam labelIcon"></i>
                                  Product Type
                                </>
                              }
                              name="productType"
                              id="productType"
                              value={formInputs?.productType}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Buyer Contact"
                              label={
                                <>
                                  <i className="bi bi-telephone labelIcon"></i>
                                  Buyer Contact
                                </>
                              }
                              name="buyerConact"
                              id="buyerConact"
                              value={formInputs?.buyerConact}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="RFQ Currency"
                              label={
                                <>
                                  <i className="bi bi-currency-rupee labelIcon"></i>
                                  RFQ Currency
                                </>
                              }
                              name="rfxCurrency"
                              id="rfxCurrency"
                              value={formInputs?.rfxCurrency}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="quotationStatus"
                              className="inputBox"
                              // label="Quotation Status"
                              label={
                                <>
                                  <i className="bi bi-flag labelIcon"></i>
                                  Quotation Status
                                </>
                              }
                              name="quotationStatus"
                              placeholder=""
                              value={"New"}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="GEM Reference Nr"
                              label={
                                <>
                                  <i className="bi bi-link-45deg labelIcon"></i>
                                  GEM Reference Nr
                                </>
                              }
                              name="gemReferenceNr"
                              id="gemReferenceNr"
                              value={formInputs?.gemReferenceNr}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Quotation overview */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible2
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility2}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">QO</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Quotation Overview
                          </span>
                          <span className="subHeaderTitle">
                            Quotation Overview
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible2 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Title:"
                              label={
                                <>
                                  <i className="bi bi-card-heading labelIcon"></i>
                                  Title
                                </>
                              }
                              name="rfxTitle"
                              id="rfxTitle"
                              value={formInputs?.rfxTitle}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Opening Date:"
                              label={
                                <>
                                  <i className="bi bi-calendar-check labelIcon"></i>
                                  Opening Date
                                </>
                              }
                              name="openingDateTime"
                              id="openingDateTime"
                              value={formatDateTime(
                                formInputs?.openingDateTime,
                              )}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Instructions Attchements:"
                              label={
                                <>
                                  <i className="bi bi-paperclip labelIcon"></i>
                                  Instructions Attachments
                                </>
                              }
                              name="rfxCurrency"
                              id="rfxCurrency"
                              value={formInputs?.rfxCurrency}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Description:"
                              label={
                                <>
                                  <i className="bi bi-text-paragraph labelIcon"></i>
                                  Description
                                </>
                              }
                              name="rfxDescription"
                              id="rfxDescription"
                              value={formInputs?.rfxDescription}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Closing Date:"
                              label={
                                <>
                                  <i className="bi bi-calendar-x labelIcon"></i>
                                  Closing Date
                                </>
                              }
                              name="closingDateTime"
                              id="closingDateTime"
                              value={formatDateTime(
                                formInputs?.closingDateTime,
                              )}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* GEM Reference Details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible10
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility10}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">GR</span>
                        </Col>
                        <Col xs={8} md={9} lg={9}>
                          <span className="headerTitle">GEM Reference</span>
                          <span className="subHeaderTitle">
                            GEM Reference Details
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible10 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="p-4">
                          <Col xs={12} md={12} lg={12}>
                            <RichTextEditor
                              value={formInputs?.gemInstuctions}
                              readOnly={true}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Price Shedule / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PI</span>
                        </Col>
                        <Col xs={12} md={4} lg={4}>
                          <span className="headerTitle">
                            Price Shedule / Line Item
                          </span>
                          <span className="subHeaderTitle">
                            Price Shedule / Line Item
                          </span>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={PRLineItemInitialCol}
                              data={itemTableData}
                              // progressPending={loading}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              // pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* other Charges table */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible5
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">OC</span>
                        </Col>

                        <Col xs={4} md={6} lg={6}>
                          <span className="headerTitle">Other Charges</span>
                          <span className="subHeaderTitle">
                            Other Charges Table{" "}
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible5 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={HeaderTextColumns}
                              data={getHeaderTextSelectedData}
                              // progressPending={loading}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              // pagination

                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Pricing Summary */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible6
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility6}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={4} lg={4}>
                          <span className="headerTitle">Pricing Summary</span>
                          <span className="subHeaderTitle">
                            Pricing Summary{" "}
                          </span>
                        </Col>
                        <Col xs={2} md={1} lg={1} className="">
                          <SourcingCommonFilter />
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible6 ? "visible" : ""
                      }`}
                    >
                      <Row className="my-4 ms-3 ">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="d-flex mb-2 jsutify-content-center align-items-center"
                        >
                          <p className="fw-medium">
                            SubTotal Pricing Schedule / Line Items (A){" "}
                          </p>
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="d-flex mb-2 jsutify-content-center align-items-center"
                        >
                          <InputField
                            id="subTotalValue"
                            className="inputBox"
                            name="subTotalValue"
                            placeholder=""
                            value={formInputs?.qtnSubTotalLineItem}
                            disabled={getDisabledStatus}
                          />
                          <p className="ms-4 fw-medium">
                            {" "}
                            {formInputs?.rfxCurrency}
                          </p>
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="d-flex mb-2 jsutify-content-center align-items-center "
                        >
                          <p className="fw-medium">
                            {" "}
                            SubTotal Other Charges (B)
                          </p>
                        </Col>
                        <Col
                          xs={12}
                          md={7}
                          lg={7}
                          className="d-flex mb-2 jsutify-content-center align-items-center "
                        >
                          <InputField
                            id="getOtherChargesValue"
                            className="inputBox"
                            name="getOtherChargesValue"
                            placeholder=""
                            value={getOtherChargesValue}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="d-flex mb-2 jsutify-content-center align-items-center"
                        >
                          <p className="fw-medium">
                            Quotation Gross Total (C = A + B)
                          </p>
                        </Col>
                        <Col
                          xs={12}
                          md={7}
                          lg={7}
                          className="d-flex mb-2 jsutify-content-center align-items-center"
                        >
                          <InputField
                            id="qtnTotal"
                            className="inputBox"
                            name="qtnTotal"
                            placeholder=""
                            value={formInputs?.qtnTotal}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
                {/* COMM - Spares & Operation Maintenance 08*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible8
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility8}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>

                        <Col xs={4} md={8} lg={7}>
                          <span className="headerTitle">
                            Product / Service Verification
                          </span>
                          {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible8 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="commTopButtonRightLeftPadding">
                          {formInputs?.formCOMM?.length > 0 &&
                            formInputs?.formCOMM?.map((formJsonData, index) => (
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                key={index}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="question_value"
                                  // label={formJsonData?.question_name}
                                  label={
                                    <>
                                      <i className="bi bi-credit-card labelIcon"></i>
                                      {formJsonData?.question_name}
                                    </>
                                  }
                                  className="inputBox"
                                  name="question_value"
                                  placeholder=""
                                  value={formJsonData?.question_value}
                                  disabled={getDisabledStatus}
                                />
                              </Col>
                            ))}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Form :TECH - Spares & Operation Maintenance09*/}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible9
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility9}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">TS</span>
                        </Col>

                        <Col xs={4} md={8} lg={7}>
                          <span className="headerTitle">
                            TECH - Spares & Operation Maintenance
                          </span>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible9 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="commTopButtonRightLeftPadding">
                          {formInputs?.formTECH?.length > 0 &&
                            formInputs?.formTECH?.map((formJsonData, index) => (
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                key={index}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="question_value"
                                  label={formJsonData?.question_name}
                                  className="inputBox"
                                  name="question_value"
                                  placeholder=""
                                  value={formJsonData?.question_value}
                                  disabled={getDisabledStatus}
                                />
                              </Col>
                            ))}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </main>
  );
};

export default TndQtnDetails;
